import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
export function getSkillChatURL(action) {
    const params = new URLSearchParams({ qfill: action.prompt });
    if (action.skills?.length) {
        params.set('qskills', action.skills.map((skill) => skill.id).join(','));
    }
    if (action.mode === SearchMode.ASI) {
        params.set('qmode', 'computer');
    }
    const pathname = action.destination === 'home' ? '/' : '/computer';
    return `${pathname}?${params.toString()}`;
}
//# sourceMappingURL=getSkillChatURL.js.map